import { isAfter, isBefore, startOfDay } from 'date-fns';
import { WebBodyText20 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { SelectProps } from '@radix-ui/react-select';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common/Select';

type TaxYearSelectProps = {} & SelectProps;

const currentDate = new Date();
const startOfYear = startOfDay(new Date(currentDate.getFullYear(), 0, 1));
const taxFilingDeadline = startOfDay(new Date(currentDate.getFullYear(), 3, 15)); // April 15th

const showPreviousYear =
  isAfter(currentDate, startOfYear) && isBefore(currentDate, taxFilingDeadline);
const years = showPreviousYear
  ? [currentDate.getFullYear(), currentDate.getFullYear() - 1]
  : [currentDate.getFullYear()];

export const TaxYearSelect = ({ value, ...props }: TaxYearSelectProps) => (
  <div className="flex items-center gap-2">
    <Select {...props} value={value}>
      <SelectTrigger className="max-w-24 bg-white" blueIcon>
        <SelectValue>
          <WebBodyText20.Bold className="first-letter:capitalize mr-2">{value}</WebBodyText20.Bold>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {years.map((year) => {
            return (
              <SelectItem key={year} value={year.toString()} className="first-letter:capitalize">
                <p className="first-letter:capitalize">{year}</p>
              </SelectItem>
            );
          })}
        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
);
